import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        maxWidth: "800px",
        margin: "auto",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#007BFF", fontSize: 38 }}>
        Privacy Policy
      </h1>
      <p>
        At <strong>Blue Washer</strong>, we value your privacy and are committed
        to protecting your personal information. This Privacy Policy outlines
        how we collect, use, and safeguard your data when you use our services.
      </p>

      <h2 className="mt-4 font-bold">Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul style={{ lineHeight: "1.8", paddingLeft: "20px" }}>
        <li>
          <strong>Personal Information:</strong> Name, contact details, and
          address provided during booking.
        </li>
        <li>
          <strong>Usage Data:</strong> Information about how you use our
          website, such as pages visited and services viewed.
        </li>
        <li>
          <strong>Payment Details:</strong> Securely processed through trusted
          payment gateways.
        </li>
      </ul>

      <h2 className="mt-4 font-bold">How We Use Your Information</h2>
      <p>Your information is used to:</p>
      <ul style={{ lineHeight: "1.8", paddingLeft: "20px" }}>
        <li>
          Provide and manage our services, including bookings and payments.
        </li>
        <li>Communicate with you about your bookings, offers, and updates.</li>
        <li>
          Enhance our website and services through analytics and feedback.
        </li>
        <li>Ensure compliance with legal obligations and prevent fraud.</li>
      </ul>

      <h2 className="mt-4 font-bold">Sharing Your Information</h2>
      <p>
        We do not sell or rent your personal information to third parties.
        However, we may share your data with trusted partners, such as payment
        processors or delivery personnel, to facilitate our services.
      </p>

      <h2 className="mt-4 font-bold">Data Security</h2>
      <p>
        We take appropriate measures to secure your personal information and
        protect it from unauthorized access, alteration, disclosure, or
        destruction. Our website uses encryption and secure protocols to ensure
        data safety.
      </p>

      <h2 className="mt-4 font-bold">Your Rights</h2>
      <p>You have the right to:</p>
      <ul style={{ lineHeight: "1.8", paddingLeft: "20px" }}>
        <li>Access, update, or delete your personal information.</li>
        <li>Withdraw consent for data processing at any time.</li>
        <li>Request clarification on how your data is used.</li>
      </ul>

      <h2 className="mt-4 font-bold">Contact Us</h2>
      <p>
        If you have any questions or concerns about our Privacy Policy, please
        contact us at
        <a href="mailto:support@bluewasher.com" style={{ color: "#007BFF" }}>
          {" "}
          support@bluewasher.com
        </a>
        .
      </p>

      <p style={{ textAlign: "center", marginTop: "20px" }}>
        <em>Last updated: 19th Jan 2025</em>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
